import { createEvent, sample } from 'effector'
import { createInfiniteList, fx } from '../../../../../libs'
import {
  RangeValue,
  TransactionsDetailsRequest,
  TransactionsDetailsResponse,
} from './types'
import { $params } from '../../../../../features/router'
import { changedDateFormat } from '../../../../../libs/utils'

export const transactionsDetailsMounted =
  createEvent<TransactionsDetailsRequest>()

export const transactionsDetailsRefresh = createEvent<void>()

export const transactionsInProgressDetailsMounted =
  createEvent<TransactionsDetailsRequest>()

export const getTransactionsDetails = fx<void, TransactionsDetailsResponse>({
  method: 'GET',
  url: '/finance/wallet/{walletID}/transaction',
})

export const getInProgressTransactions = fx<void, TransactionsDetailsResponse>({
  method: 'GET',
  url: '/finance/transaction',
})

const walletTransactions = createInfiniteList(getTransactionsDetails)
const inProgressTransactions = createInfiniteList(getInProgressTransactions)

export const $transactionsDetails = walletTransactions.$items
export const $totalCountOfTransactionsDetail = walletTransactions.$total
export const $loadedPageOfTransactionsDetail = walletTransactions.$loadedPage
export const $hasMoreTransactionsDetail = walletTransactions.$hasMore

export const $transactionsInProgress = inProgressTransactions.$items
export const $totalCountOfTransactionsInProgress = inProgressTransactions.$total
export const $loadedPageOfTransactionsInProgress =
  inProgressTransactions.$loadedPage
export const $hasMoreTransactionsInProgress = inProgressTransactions.$hasMore

sample({
  // @ts-ignore
  clock: transactionsDetailsMounted,
  source: $params,
  fn: (
    params,
    { limit, page, searchText, filters, orderBy, orderDirection },
  ) => {
    let filtersTransactionsParams = {}

    let query = {
      limit,
      page,
    }

    if (orderBy && orderDirection) {
      // @ts-ignore
      query['order'] = `${orderDirection === 'asc' ? '' : '-'}${orderBy}`
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      filtersTransactionsParams = Object.keys(filters).reduce(
        (accumulator, key) => {
          if (filters[key as keyof typeof filters] != null) {
            if (key === 'currency' || key === 'gateways' || key === 'type') {
              accumulator[key as keyof typeof filters] =
                filters[key as keyof typeof filters]
            } else if (key === 'period') {
              if ((filters[key as keyof typeof filters] as RangeValue)[0]) {
                accumulator['dateFrom'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[0].$d,
                )
              }
              if ((filters[key as keyof typeof filters] as RangeValue)[1]) {
                accumulator['dateTo'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[1].$d,
                )
              }
            } else {
              accumulator[key as keyof typeof filters] = `${
                filters[key as keyof typeof filters]
              }`
            }
          }

          return accumulator
        },
        {} as any,
      )
    }

    if (searchText) {
      filtersTransactionsParams = {
        ...filtersTransactionsParams,
        id: searchText,
      }
    }

    if (Object.keys(filtersTransactionsParams).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(filtersTransactionsParams)}`
    }

    return {
      url: `/finance/wallet/${params?.walletID}/transaction`,
      query,
    }
  },
  target: getTransactionsDetails,
})

sample({
  // @ts-ignore
  clock: transactionsInProgressDetailsMounted,
  fn: ({ limit, page, searchText, filters, orderBy, orderDirection }) => {
    let filtersTransactionsParams = {}

    let query = {
      limit,
      page,
      populate: JSON.stringify(['Wallet']),
    }

    if (orderBy && orderDirection) {
      // @ts-ignore
      query['order'] = `${orderDirection === 'asc' ? '' : '-'}${orderBy}`
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      filtersTransactionsParams = Object.keys(filters).reduce(
        (accumulator, key) => {
          if (filters[key as keyof typeof filters] != null) {
            if (key === 'currency' || key === 'gateways') {
              accumulator[key as keyof typeof filters] =
                filters[key as keyof typeof filters]
            } else if (key === 'period') {
              if ((filters[key as keyof typeof filters] as RangeValue)[0]) {
                accumulator['dateFrom'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[0].$d,
                )
              }
              if ((filters[key as keyof typeof filters] as RangeValue)[1]) {
                accumulator['dateTo'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[1].$d,
                )
              }
            } else {
              accumulator[key as keyof typeof filters] = `${
                filters[key as keyof typeof filters]
              }`
            }
          }

          return accumulator
        },
        {} as any,
      )
    }

    if (searchText) {
      filtersTransactionsParams = {
        ...filtersTransactionsParams,
        id: searchText,
        inProgress: true,
      }
    }

    if (Object.keys(filtersTransactionsParams).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(filtersTransactionsParams)}`
    } else {
      // @ts-ignore
      query['where'] = `${JSON.stringify({ inProgress: true })}`
    }

    return {
      url: `/finance/transaction`,
      query,
    }
  },
  target: getInProgressTransactions,
})
